import React, { useEffect } from 'react';
import { Card } from 'antd';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import {Icon} from 'leaflet'

/* import { TileLayer } from 'react-leaflet/TileLayer';
import { Marker } from 'react-leaflet/Marker';
import { Popup } from 'react-leaflet/Popup'; */

function LocationMap(props) {
    const MapRecenter= ({ lat, lng, zoomLevel }) => {
      const map = useMap();
    
      useEffect(() => {
        // Fly to that coordinates and set new zoom level
        map.setView([lat, lng], zoomLevel );
      }, [lat, lng]);
      return null;
    
    };

    if (!props.location || !props.location.latitude || !props.location.longitude) {
      console.warn('location map non ha dati di latitudine e longitudine, props: ', props);
      return (      
        <Card variant="borderless" loading>
          No location data available
        </Card>
      );
    }
    
    // console.warn('props di location map', props);
    return (
      <Card variant="borderless" width="100%" loading={false} style={{ boxShadow: 'none', padding: 0 }}>
        <MapContainer center={[props.location.longitude,props.location.latitude]} zoom={17} scrollWheelZoom={false} style={{ width: "100%", height: "45vh" }}>
          <MapRecenter lat={props.location.longitude} lng={props.location.latitude} zoomLevel={17} />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {props.multipleLocations && props.multipleLocations.map((location) => (
            <Marker key={location.id} position={[location.longitude, location.latitude]} icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})}>
              <Popup>
                <b>{location.name}</b>
                <br />
                {location.address}
              </Popup>
            </Marker>
          ))}
          {!props.multipleLocations &&
            <Marker position={[props.location.longitude,props.location.latitude]} icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})}>
              <Popup>
                  <b>{props.location.name}</b>
                  <br />
                {props.location.address}
              </Popup>
            </Marker>
          }
        </MapContainer>
      </Card>
    );
}

export default LocationMap;